var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    isAuthorized: false,
    syfIdentifier: '',
    token: '',
    errorCode: ''
};
var authorizationSlice = createSlice({
    name: 'authorization',
    initialState: initialState,
    reducers: {
        authorizationSuccess: function (state, _a) {
            var token = _a.payload;
            return __assign(__assign({}, state), { token: token, isAuthorized: true, errorCode: '' });
        },
        authorizationFailed: function (state, _a) {
            var errorCode = _a.payload;
            return __assign(__assign({}, state), { errorCode: errorCode, isAuthorized: false, token: '', syfIdentifier: '' });
        },
        setAccountId: function (state, _a) {
            var syfIdentifier = _a.payload;
            return __assign(__assign({}, state), { syfIdentifier: syfIdentifier });
        }
    }
});
export var authorizationSuccess = (_a = authorizationSlice.actions, _a.authorizationSuccess), authorizationFailed = _a.authorizationFailed, setAccountId = _a.setAccountId;
export default authorizationSlice.reducer;
